module.exports = __webpack_public_path__ + "img/seat.31caadcc.png";